import { useTranslations } from '@vocab/react';
import {
  Stack,
  Inline,
  Heading,
  Text,
  TooltipRenderer,
  Box,
  IconInfo,
} from 'braid-design-system';

import AnimatedHeight from 'src/components/AnimatedHeight/AnimatedHeight';

import { CardsStack } from '../SharedComponent/CardsStack/CardsStack';
import { ErrorState } from '../SharedComponent/ErrorState/ErrorState';
import { useSignedInDashboardContext } from '../SignedInDashboardContextProvider';
import { CAREER_FEED_LIMIT } from '../hooks/useCareerFeed';

import translations from './.vocab';
import { CareerFeedEmptyState } from './CareerFeedEmptyState';
import { CareerFeedItems } from './CareerFeedItems';
import { CareerFeedLoadingState } from './CareerFeedLoadingState';

const CareerFeedContent = () => {
  const {
    careerFeedResult: { loading, feedItems, error },
  } = useSignedInDashboardContext();

  if (loading) {
    return (
      <CareerFeedLoadingState length={CAREER_FEED_LIMIT} keyPrefix="recs" />
    );
  }

  if (error) {
    return <ErrorState section="careerFeed" />;
  }

  if (feedItems.length === 0) {
    return <CareerFeedEmptyState />;
  }

  return (
    <CardsStack>
      <CareerFeedItems feedItems={feedItems} />
    </CardsStack>
  );
};

export const CareerFeed = () => {
  const { t } = useTranslations(translations);
  const {
    careerFeedResult: { loading, feedItems },
  } = useSignedInDashboardContext();

  return (
    <Stack space="small">
      <Inline space="xxsmall" alignY="center">
        <Heading level="3">{t('Recommended jobs')}</Heading>
        <TooltipRenderer
          id=""
          tooltip={
            <Text align="center" size="small">
              {t('Based on your profile, job views and applications.')}
            </Text>
          }
        >
          {({ triggerProps }) => (
            <Box aria-label="Info" {...triggerProps}>
              <IconInfo size="xsmall" />
            </Box>
          )}
        </TooltipRenderer>
      </Inline>

      <AnimatedHeight changeKeys={[loading, feedItems]}>
        <CareerFeedContent />
      </AnimatedHeight>
    </Stack>
  );
};
